export default [
    {
        id: 1,
        title: "YouTube Clone",
        description: "The homepage of youtube.com cloned while learning HTML and CSS",
        coverImg: "./img/youtubeclone.png",
        languages: {
            one: "HTML",
            two: "CSS"
        }
    },
    {
        id: 2,
        title: "Portfolio Page",
        description: "My very own portfolio page created as a part of the membership drive at WebDev Club TSEC",
        coverImg: "./img/portfolio.png",
        languages: {
            one: "HTML",
            two: "CSS",
            three: "JavaScript",
            four: "ReactJS"
        }
    }

    
    ]